import { ref, computed } from '@vue/composition-api';

const breadcrumb = ref([]);
const sticky = ref(false);

export default function useBreadcrumb() {
  function setBreadcrumb(newBreadcrumb) {
    breadcrumb.value = newBreadcrumb;
  }

  function setBreadcrumbSticky(value) {
    sticky.value = value;
  }

  return {
    breadcrumb: computed(() => breadcrumb.value),
    sticky: computed(() => sticky.value),
    setBreadcrumb,
    setBreadcrumbSticky,
  };
}
